import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { requestPasswordReset } from '../services/authService';

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const { error: resetError } = await requestPasswordReset(email);
      if (resetError) {
        setError(resetError);
        setLoading(false);
      } else {
        setSuccess('Password reset email sent! Check your inbox for instructions.');
        setEmail('');
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    } catch (err) {
      setError('Failed to send password reset email');
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center bg-white">
      <div className="w-full max-w-2xl">
        <div className="space-y-2">
          <div className="mb-2">
            <h1 className="text-xl font-bold text-gray-900">RESET PASSWORD</h1>
            <p className="text-gray-600 text-xs">Enter your email to reset your password</p>
          </div>

          {error && (
            <div className="p-1.5 bg-red-50 border border-red-200 text-red-700 rounded text-xs mb-2">
              {error}
            </div>
          )}

          {success && (
            <div className="p-1.5 bg-green-50 border border-green-200 text-green-700 rounded text-xs mb-2">
              {success}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-2">
            <div>
              <label htmlFor="email" className="block text-xs font-medium text-gray-700 mb-0.5">
                Email
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-3 py-1.5 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                placeholder="you@example.com"
                required
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-indigo-600 text-white py-1.5 rounded hover:bg-indigo-700 transition-colors disabled:opacity-50 font-medium text-sm"
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>

          <p className="text-center text-xs text-gray-600">
            Remember your password?{' '}
            <Link 
              to="/login"
              className="text-indigo-600 hover:text-indigo-700 font-medium"
            >
              Back to Login
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
